import type { AuthRepositoryPort } from "../ports/auth.repository.port";

export function resetPasswordUseCase(repository: AuthRepositoryPort, token: string, newPassword: string) {
  return repository.resetPassword(token, newPassword);
}
